import React from 'react';
import { Reveal } from './Reveal';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-10 px-[5vw] bg-white" data-id="element-307">
      <div className="max-w-lg mx-auto" data-id="element-308">
        <Reveal data-id="element-309">
          <div className="bg-white rounded-[20px] border border-line p-5 md:p-6 text-center relative overflow-hidden" data-id="element-310">
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#059669]" data-id="element-311"></div>

            <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#059669]/10 mb-3" data-id="element-312">
              <ShieldCheck size={20} className="text-[#059669]" data-id="element-313" />
            </div>

            <h3 className="font-serif font-bold text-[18px] md:text-[22px] tracking-[-0.02em] text-ink mb-3 leading-tight" data-id="element-314">
              Garantia de 7 dias. Sem perguntas. Sem letra miúda.
            </h3>

            <p className="text-[13px] md:text-[14px] leading-[1.6] text-ink-soft max-w-sm mx-auto mb-4" data-id="element-315">
              Use por 7 dias. Se sentir que não é pra você — por qualquer motivo
              — devolvemos 100% do que você pagou. Sem perguntas. Sem retenção.
            </p>

            <div className="inline-flex items-center gap-1.5 bg-[#059669]/10 border border-[#059669]/20 rounded-full px-4 py-1.5" data-id="element-316">
              <ShieldCheck size={13} className="text-[#059669]" data-id="element-317" />
              <span className="text-[11px] font-bold tracking-wider text-[#059669] uppercase" data-id="element-318">
                Garantia Incondicional · 7 Dias
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}